export const directDebitTypes = {
  NONE: { Id: 0, Code: 'None', Label: 'None' },
  BANK_ACCOUNT: { Id: 1, Code: 'BankAccount', Label: 'Bank Account' },
  CREDIT_CARD: { Id: 2, Code: 'CreditCard', Label: 'Credit Card' }
};
